import { z } from 'zod';
import { FamilyInteractionId, FamilyId, StudentId, UserId } from '../types/branded';
import { NoteCategorySchema, NoteVisibilitySchema } from '../types/enums';

export const FamilyInteractionSchema = z.object({
  id: FamilyInteractionId,
  familyId: FamilyId.nullable().optional(),
  studentId: StudentId.nullable().optional(),
  eventType: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  authorId: UserId,
  authorName: z.string().min(1),
  content: z.string().min(1),
  category: NoteCategorySchema,
  isImportant: z.boolean().default(false),
  attachments: z.array(z.object({
    attachmentId: z.string().nullable().optional(),
    fileName: z.string(),
    contentType: z.string().nullable().optional(),
    sizeBytes: z.number().int().nonnegative().nullable().optional(),
    storageKey: z.string().nullable().optional(),
  })).default([]),
  visibility: NoteVisibilitySchema.default('internal'),
  deletedAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type FamilyInteraction = z.infer<typeof FamilyInteractionSchema>;
